import {FC, useState} from "react";
import {Employee, EmployeeType, employeeTypesOptions} from "../../../lib/src/api/dto/Employee";
import {ModalFooter} from "../../../lib/src/components/layout/ModalProvider";
import {faSave} from "@fortawesome/free-solid-svg-icons";
import {Select} from "../../../lib/src/components/form/Select";
import {ValidationError} from "../api/api";
import {useApi} from "../api/APIContext";

export const EditEmployeeTypeModal: FC<{ employee: Employee }> = (props) => {
  const {updateEmployeeMetadata} = useApi()
  const [employeeType, setEmployeeType] = useState(props.employee.metadata.employeeType)
  const [errors, setErrors] = useState<string[]>([])


  const confirm = async () => {
    // TODO: pass employeeType
    await updateEmployeeMetadata(props.employee.id,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      employeeType as EmployeeType)
      .catch(e => {
        if (e instanceof ValidationError) {
          setErrors(Object.values(e.errors).flat())
        }
        throw e
      })
  }

  return <>
    <Select label={'Medewerker type'} options={employeeTypesOptions} value={employeeType ?? '?'} onChange={setEmployeeType} />
    <ModalFooter text={'Opslaan'} icon={faSave} onSubmit={confirm}/>
  </>
}